import { render, staticRenderFns } from "./ValidatedWorkerList.vue?vue&type=template&id=c2ac3de8&scoped=true"
import script from "./ValidatedWorkerList.vue?vue&type=script&lang=ts"
export * from "./ValidatedWorkerList.vue?vue&type=script&lang=ts"
import style0 from "./ValidatedWorkerList.vue?vue&type=style&index=0&id=c2ac3de8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ac3de8",
  null
  
)

export default component.exports